module.exports = "dist/69f8a0617ac472f78e45841323a3df9e.woff2";


//////////////////
// WEBPACK FOOTER
// ./~/materialize-css/fonts/roboto/Roboto-Light.woff2
// module id = 208
// module chunks = 0